import styled from 'styled-components';
import { getColorForDay } from './utils';

interface TimeUnitMatrixWrapperProps {
    isWeekendDay: boolean;
    isCurrentTimeUnit: boolean;
}

export const TimeUnitMatrixWrapper = styled.div<TimeUnitMatrixWrapperProps>`
    text-align: left;
    background: ${getColorForDay};
`;
